export const fmtM = (v: number | null | undefined): string =>
  !v
    ? '0.0'
    : (v / 1e6).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const fmtPct = (v: number | null | undefined): string =>
  v == null ? '—' : `${(v * 100).toFixed(1)}%`;

export const fmtBn = (v: number): string => `${(v / 1e9).toFixed(2)}bn`;

export const fmtBig = (v: number | null | undefined): string =>
  v == null
    ? '—'
    : v >= 1e9
      ? `${(v / 1e9).toFixed(2)}bn`
      : v >= 1e6
        ? `${(v / 1e6).toFixed(1)}M`
        : v >= 1e3
          ? `${(v / 1e3).toFixed(0)}k`
          : String(v);

export function growthText(v: number | null | undefined): {
  text: string;
  cls: 'pos' | 'neg' | 'nil';
} {
  if (v == null) return { text: '—', cls: 'nil' };
  return {
    text: `${v > 0 ? '+' : ''}${(v * 100).toFixed(1)}%`,
    cls: v > 0 ? 'pos' : v < 0 ? 'neg' : 'nil',
  };
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const monthLabel = (m: string): string =>
  `${MONTHS[Number(m.slice(5, 7)) - 1]} '${m.slice(2, 4)}`;

export const territoryName = (t: string): string =>
  ({ WW: 'Worldwide', US: 'US', EX: 'Ex-US' })[t] ?? t;

export const CLASS_LABEL: Record<string, string> = {
  release: 'Release',
  revival: 'Revival',
  campaign: 'Campaign',
  unattributed: 'Unknown',
};
